import {
  LayoutTemplate,
  ClipboardList,
  Bell,
  BarChart3,
  Target,
  Smartphone,
} from "lucide-react";

const SERVICES = [
  {
    icon: LayoutTemplate,
    title: "Landing page",
    body: "Szybka, czytelna, premium. Jeden cel: zostawienie numeru.",
  },
  {
    icon: ClipboardList,
    title: "Formularze",
    body: "Krótkie, mobilne, z walidacją i sensowną logiką pól.",
  },
  {
    icon: Bell,
    title: "Powiadomienia",
    body: "Lead leci e-mailem i na Telegram w 2 sekundy. Nic nie ginie.",
  },
  {
    icon: BarChart3,
    title: "Analityka",
    body: "GA4 + GTM, zdarzenia konwersji, jasne dane do decyzji.",
  },
  {
    icon: Target,
    title: "Google Ads",
    body: "Kampanie na zapytania transakcyjne, optymalizacja pod telefony.",
  },
  {
    icon: Smartphone,
    title: "Mobile UX",
    body: "Każdy piksel projektowany z telefonu. Sticky CTA, tap targets ≥48px.",
  },
];

export default function AgencyServices() {
  return (
    <section
      id="co-robimy"
      data-testid="agency-services"
      className="relative py-20 lg:py-28 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-10">
        <div className="max-w-3xl">
          <div className="text-[11px] font-bold uppercase tracking-[0.18em] text-brand-yellow">
            Co robimy
          </div>
          <h2 className="mt-3 font-heading font-extrabold text-white text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.05]">
            Pełna maszyna leadowa,{" "}
            <span className="text-white/40">a nie tylko strona.</span>
          </h2>
        </div>

        <div className="mt-12 lg:mt-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-5">
          {SERVICES.map(({ icon: Icon, title, body }, i) => (
            <div
              key={title}
              data-testid={`agency-service-card-${i}`}
              className="group relative rounded-3xl bg-gradient-to-b from-white/[0.05] to-white/[0.02] ring-1 ring-white/10 p-7 hover:ring-brand-yellow/30 transition-all"
            >
              <div className="flex items-start gap-4">
                <div className="grid place-items-center h-11 w-11 rounded-xl bg-brand-yellow text-brand-yellowFg shadow-md flex-shrink-0">
                  <Icon className="h-5 w-5" strokeWidth={2.4} />
                </div>
                <div>
                  <h3 className="font-heading font-bold text-white text-lg tracking-tight">
                    {title}
                  </h3>
                  <p className="mt-2 text-[14.5px] text-white/55 leading-relaxed">
                    {body}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
